










import { Vue, Component } from 'vue-property-decorator';
import BitacoraBase from './BitacoraBase.vue';

@Component({
  components: { BitacoraBase },
})
export default class BitacoraPantalla extends Vue {
  permiso: any = JSON.parse(localStorage.getItem('user')).permisosUsuario[0]
    .nombrePerfil;
}
